import { getEnv } from "@/lib/get_env";
import { WebStorageStateStore } from "oidc-client-ts";

export const oidcConfig = {
  authority: getEnv("VITE_OIDC_AUTHORITY"),
  client_id: getEnv("VITE_OIDC_CLIENT_ID"),
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid profile email offline_access",
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
  automaticSilentRenew: true,
};
